export default __webpack_public_path__ + "static/media/trivia-react-redux.9054b7eb.png";